<template>
	<div v-if="loading">
		<div class="row">
			<div class="col-12">
				<label class="font28 font500"> <mdb-icon icon="book" />ข้อมูลสมุดโทรศัพท์ </label>
			</div>
		</div>
		<div class="row">
			<div class="col-12 col-md-4 py-1 px-2">
				<router-link to="Setuser">
					<button type="button" class="btn btn-cancel color_white font12" style="font-weight:400;"><i class="fas fa-angle-double-left"></i> ย้อนกลับ</button> </router-link
				>สมุดโทรศัพท์
			</div>
		</div>
		<!-- <div class="row">
			<div class="align-self-center ml-3">แผนก</div>
			<div class="col-12 col-md-3 p-2">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" id="basic-addon">
							<mdb-icon far icon="edit" />
						</span>
					</div>
					<input type="text" v-model="payload.search_book" class="form-control" aria-describedby="basic-addon" width="80%" />
				</div>
			</div>
    </div>-->
		<div class="row">
			<div class="align-self-center ml-3">ชื่อสมุดโทรศัพท์</div>
			<div class="col-12 col-md-4 p-2">
				<div class="input-group">
					<div class="input-group-prepend">
						<span class="input-group-text" id="basic-addon">
							<mdb-icon far icon="edit" />
						</span>
					</div>
					<input type="text" v-model="book_name" class="form-control" aria-describedby="basic-addon" width="80%" @keypress="isCharacter($event)" />
				</div>
			</div>
			<div class="align-self-center col-12 col-md-auto py-1">
				<mdb-form-inline>
					<mdb-input type="radio" id="option1" name="groupOfMaterialRadios2" radioValue="1" v-model="selected" label="เพิ่มทีละหมายเลข" />
					<mdb-input type="radio" id="option2" name="groupOfMaterialRadios2" radioValue="2" v-model="selected" label="อัพโหลดไฟล์" />
				</mdb-form-inline>
			</div>
		</div>
		<div class="row" v-show="selected === '1'">
			<div class="col-12">
				<div class="font14 mt-3">กรอกหมายเลขโทรศัพท์มือถือ</div>
				<textarea v-model="phone_number" @keypress="isNumber($event)" rows="5" maxlength="10" style="width:100%;"></textarea>
				<div class="font14 color_gray mt-3">- หมายเลขโทรศัพท์ 10 หลัก</div>
				<div class="font14 color_gray">- หรือ สามารถ Copy หมายเลขโทรศัพท์ จาก text editer ,excel มาวางได้</div>
			</div>
		</div>
		<div class="row mt-4 ml-0" v-show="selected === '2'">
			<div id="app">
				<label>
					<b class="ml-3">File</b>
					<input id="file" type="file" :disabled="disabled" class="px-2" ref="file" style="max-width:250px;" @change="handleFileUpload()" />
				</label>
				<mdb-btn class="btn-uploadfile py-2 px-3 ml-3 mt-2 mb-3 btn_upload" id="btn_upload" v-if="isupload" :disabled="disabled" @click="uploadfile_post()"> <mdb-icon icon="file-upload" />Upload File </mdb-btn>
				<mdb-btn class="btn-uploadfile py-2 px-3 ml-3 mt-2 mb-3 btn_cancel" id="btn_cancel" v-if="iscancel" @click="uploadfile_cancel()"> <mdb-icon icon="times" />Cancel </mdb-btn>
			</div>
			<!-- <form class="md-form">
				<div class="file-field">
					<div class="btn btn-primary btn-sm float-left">
						<span>Choose file</span>
						<input type="file" />
					</div>
					<div class="file-path-wrapper">
						<input class="file-path validate" type="text" placeholder="Upload your file" />
					</div>
				</div>
      </form>-->
			<!-- <mdb-file-input type="file" v-model="phone_upload" btnColor="mdb-color" rounded btn-title="เลือกไฟล์" /> -->
			<!-- <mdb-btn class="btn-uploadfile my-2 ml-2"><mdb-icon icon="file-upload" /> Upload File</mdb-btn> -->
			<div class="mt-3" style="display: flex;">
				<div class="font14 color_gray mt-2">
					<p>**อัพโหลดไฟล์ขนาดไม่เกิน 5 MB และกรุณาใช้ฟอร์แมตไฟล์ตามที่กำหนด (นามสกุลไฟล์)</p>
				</div>
				<p class="font14 color_gray mt-2 ml-2">.txt (ANSI/ASCII,UTF-8)</p>
				<p class="font14 color_gray mt-2 ml-2">.csv (Comma delimited)</p>
			</div>
		</div>

		<div class="col-12 text-center mt-5">
			<button type="button" class="btn btn-search color_white mr-3 font12" style="font-weight:400;" :disabled="disabled" @click="SaveOnClick()">บันทึก</button>
			<button type="button" :disabled="disabled" class="btn btn-cancel color_white font12" style="font-weight:400;" @click="OnCancleData()">ยกเลิก</button>
		</div>
	</div>
</template>

<script>
	//import axios from 'axios'
	import {mapGetters, mapActions} from 'vuex'
	export default {
		name: 'Setuseradd',
		data() {
			return {
				selected: '1',
				getFileInputValue: '',
				book_name: '',
				phone_number: '',
				phone_upload: '',
				file: null,
				id_upload_file: null,
				loading: false,
				isupload: true,
				iscancel: false,
				disabled: false,
				showoploads: true,
			}
		},
		computed: {
			...mapGetters({
				isLogin: 'isLogin',
				user: 'user',
				token: 'token',
			}),
		},
		methods: {
			...mapActions({
				storeLogin: 'login',
				storeLoout: 'logout',
				loadsession: 'loadsession',
				callApiMotherFucker: 'callApiMotherFucker',
			}),
			isCharacter: function(evt) {
				evt = evt ? evt : window.event
				var charCode = evt.which ? evt.which : evt.keyCode
				if (charCode < 48 || (charCode > 57 && charCode < 65) || (charCode > 90 && charCode < 97) || charCode > 122) {
					evt.preventDefault()
				} else {
					return true
				}
			},
			isNumber: function(evt) {
				evt = evt ? evt : window.event
				var charCode = evt.which ? evt.which : evt.keyCode
				if ((charCode == 60 && charCode < 48) || charCode > 57) {
					evt.preventDefault()
				} else {
					// this.phone_number.split(',').length
					return true
				}
			},
			handleFileUpload() {
				this.file = this.$refs.file.files[0]
			},
			uploadfile_post() {
				if (this.file != null) {
					this.disabled = true
					let formData = new FormData()
					formData.append('file', this.file)
					formData.append('title', 'bookphone')
					// console.log('>> formData >> ', formData)
					this.$axios
						.post('/upload_file', formData, {
							headers: {
								Authorization: this.token.headers.Authorization,
								'Content-Type': 'multipart/form-data',
							},
						})
						.then((res) => {
							this.showoploads = false
							this.disabled = false
							this.iscancel = true
							this.isupload = false
							this.id_upload_file = res.data.id
							if (res.data.code == 0) {
								this.$swal({
									icon: 'success',
									html: res.data.msg,
									timer: 5000,
									showConfirmButton: true,
									allowOutsideClick: false,
									allowEscapeKey: false,
								})
							} else {
								this.$swal({
									icon: 'error',
									html: res.data.msg,
									timer: 5000,
									showConfirmButton: true,
									allowOutsideClick: false,
									allowEscapeKey: false,
								})
							}
						})
						.catch(function() {
							console.log('FAILURE!!')
						})
				} else {
					this.$swal({
						icon: 'error',
						html: '<br>กรุณาเลือก ไฟล์อัพโหลดก่อน!!!<br>',
						timer: 8000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}
			},
			uploadfile_cancel() {
				let payload = {
					id: this.id_upload_file ? this.id_upload_file : 0, //wait api
					rowkey: 'delete',
				}
				this.callApiMotherFucker({
					method: 'delete',
					path: '/bookphone',
					data: payload,
				}).then(() => {
					this.$swal({
						icon: 'success',
						html: '<br>ยกเลิกอัพโหลดไฟล์เรียบร้อยแล้ว<br>',
						timer: 8000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
					this.isupload = true
					this.iscancel = false
				})
				this.file = null
				window.location.reload()
			},
			OnCancleData() {
				this.$router.push('/Setuser')
				let payload = {
					id: this.id_upload_file ? this.id_upload_file : 0, //wait api
					rowkey: 'cancel',
				}
				this.callApiMotherFucker({
					method: 'post',
					path: '/confirm_bookphone',
					data: payload,
				}).then((res) => {
					console.log('ress', res)
				})
			},
			SaveOnClick() {
				if (this.book_name == '') {
					return this.$swal({
						html: '<i class="fa fa-address-book fa-6x"></i><br><br>กรุณากรอกชื่อสมุดโทรศัพท์<br>',
						timer: 8000,
						showConfirmButton: true,
						allowOutsideClick: false,
						allowEscapeKey: false,
					})
				}
				if (this.selected == '1') {
					if (this.phone_number == '') {
						return this.$swal({
							html: '<i class="fa fa-mobile-alt fa-6x"></i><br><br>กรุณากรอกหมายเลขโทรศัพท์<br>',
							timer: 8000,
							showConfirmButton: true,
							allowOutsideClick: false,
							allowEscapeKey: false,
						})
					}
					let payload_phone = {
						rowkey: 'approve',
						book_name: this.book_name,
						phone_number: this.phone_number,
						type: '1',
					}
					console.log(payload_phone)
					this.callApiMotherFucker({
						method: 'PUT',
						path: '/bookphone',
						data: payload_phone,
					}).then((res) => {
						console.log('payload', res.payload)
						if (res.code == 0) {
							this.$swal({
								icon: 'success',
								html: res.msg,
								timer: 8000,
								showConfirmButton: true,
								allowOutsideClick: false,
								allowEscapeKey: false,
							})
							this.$router.push('/Setuser')
						} else {
							this.$swal({
								icon: 'error',
								html: res.msg,
								timer: 8000,
								showConfirmButton: true,
								allowOutsideClick: false,
								allowEscapeKey: false,
							})
							this.$router.push('/Setuser')
						}
					})
				}
				if (this.selected == '2') {
					let payload_upload = {
						rowkey: 'approve',
						id: this.id_upload_file,
						book_name: this.book_name,
						type: '2',
					}
					this.callApiMotherFucker({
						method: 'PUT',
						path: '/bookphone',
						data: payload_upload,
					}).then((res) => {
						console.log('payload', res.payload)
						if (res.code == 0) {
							this.$swal({
								icon: 'success',
								html: res.msg,
								timer: 8000,
								showConfirmButton: true,
								allowOutsideClick: false,
								allowEscapeKey: false,
							})
							this.$router.push('/Setuser')
						} else {
							this.$swal({
								icon: 'error',
								html: res.msg,
								timer: 8000,
								showConfirmButton: true,
								allowOutsideClick: false,
								allowEscapeKey: false,
							})
							this.$router.push('/Setuser')
						}
					})
				}
			},
		},
		mounted() {
			this.loading = true
		},
	}
</script>

<style scoped>
	.md-form {
		margin-top: 0rem;
		margin-bottom: 0rem;
	}
</style>
